import type { FaireProductEntity } from "../../entity_types/product";

export const p_4ynyj23hdg: FaireProductEntity = {
  token: "p_4ynyj23hdg",
  type: "product",
  name: "Rosina Blanket - Iris / Rust",
  brandToken: "b_b0bmnnd12t",
  brandName: "Morrow Soft Goods",
  imageUrl:
    "https://cdn.faire.com/fastly/62a323b7d2523d044ea3fb204e4fd8eff6241b3be68506de61015d57a6cf4e38.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4355e8bfbd3a90898c067b3cf879f33b42c6a26c6cf1045845a1c1c24d571250.jpeg",
  ],
  priceDollars: 120.9,
  description:
    "\nThe Rosina Blanket features an intricately woven geometric design in an unexpected mix of soft purple and warm rust. Inspired by vintage textiles, this blanket effortlessly brings color and pattern into the space. \n\n",
  tags: [],
  msrpDollars: 195,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T18:10:57.579Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
